import { render, staticRenderFns } from "./submitWorkOrder.vue?vue&type=template&id=720f4213&scoped=true&"
import script from "./submitWorkOrder.vue?vue&type=script&lang=js&"
export * from "./submitWorkOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720f4213",
  null
  
)

export default component.exports